/* global __webpack_hash__ */
// Detecta si hay un frontend nuevo desplegado comparando el hash con el que se
// compiló esta pestaña contra /version.json — SPEC_AVISO_NUEVA_VERSION_v0.1.md.
//
// **Nunca recarga por su cuenta** (RN-172): sólo prende `updateAvailable`.
// Recargar lo decide el operador, que puede tener un cobro a medio cargar.
//
// Portado de POS_GRACIELA (`a1e37f8`). Las dos decisiones puras viven en
// `utils/versionApp.mjs` para probarlas sin navegador (PA-3).
import { ref } from 'vue'
import { hayVersionNueva, esErrorDeChunk } from '@/utils/versionApp.mjs'

// RN-178: en el dev server —incluido el del arnés E2E— está apagado.
const ENABLED = process.env.NODE_ENV === 'production'
const CURRENT_BUILD = __webpack_hash__
const VERSION_URL = `${process.env.BASE_URL || '/'}version.json`
const INTERVAL_MS = 10 * 60 * 1000

export const updateAvailable = ref(false)

let checking = false
let started = false

export async function checkForUpdate () {
  if (!ENABLED || updateAvailable.value || checking) return
  checking = true
  try {
    // `no-store` y `?t=` (PA-2): hoy no hay caché intermedia, y esquivarla igual
    // cuesta nada.
    const response = await fetch(`${VERSION_URL}?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return
    if (hayVersionNueva(CURRENT_BUILD, await response.json())) {
      updateAvailable.value = true
    }
  } catch {
    // Sin red, servidor caído o una respuesta que no es JSON: no se avisa nada
    // (RN-177).
  } finally {
    checking = false
  }
}

// RN-175: al volver a la pestaña o a la ventana, y cada 10 min mientras se ve.
export function startVersionWatch () {
  if (!ENABLED || started) return
  started = true

  checkForUpdate()
  window.setInterval(() => {
    if (document.visibilityState === 'visible') checkForUpdate()
  }, INTERVAL_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForUpdate()
  })
  window.addEventListener('focus', checkForUpdate)
}

// PA-6: limpiar Cache Storage es defensivo —hoy no hay service worker—. La
// recarga trae el `index.html` nuevo porque nginx lo sirve con `no-cache`.
export async function applyUpdate () {
  try {
    if ('caches' in window) {
      const keys = await window.caches.keys()
      await Promise.all(keys.map((key) => window.caches.delete(key)))
    }
  } catch {
    // Si la limpieza falla, la recarga igual trae el index.html nuevo.
  }
  window.location.reload()
}

export const isChunkLoadError = esErrorDeChunk
